import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import type { IPagination, IPaginationParams } from "@/types/pagination";
import type { IExamSet, ExamSetStatus } from "./types";

export type IExamSetListParams = IPaginationParams & {
  title?: string;
  status?: ExamSetStatus;
};

export type IExamSetListResponse = IPagination<IExamSet>;

export const apiGetExamSetList = async (params?: IExamSetListParams) => {
  return apiGet<IExamSetListResponse>("/exam_sets", params);
};

export const useQueryGetExamSetList = (
  params: IExamSetListParams = {},
  options = {}
) => {
  return useQuery({
    queryKey: ["exam_sets", params],
    queryFn: () => apiGetExamSetList(params),
    select: (response) => response.data,
    ...options,
  });
};

export default useQueryGetExamSetList;
